import { render } from "./FolderTable.vue?vue&type=template&id=661b9f43&scoped=true"
import script from "./FolderTable.vue?vue&type=script&lang=js"
export * from "./FolderTable.vue?vue&type=script&lang=js"

import "./FolderTable.vue?vue&type=style&index=0&id=661b9f43&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661b9f43"]])

export default __exports__